// Property toggle function.  If both property and value are provided,
// function will set the property to the provided value.  If no value
// is provided, function will toggle the current value for the property.
export const toggle = (property, value) => {
  this[property] = (typeof value === 'boolean' ? value : !this[property])
}
